import { useHistory } from 'react-router-dom';
import { useReducer } from 'react';
import constate from 'constate';
import createReducer from 'helpers/reducers-helper';
import assign from 'lodash/assign';
import get from 'lodash/get';
import {
  useAppContext,
  UPDATE_USER_INFO,
  SHOW_APP_MESSAGE,
  NOW_SETTING_CREDIT_CARD,
  NOW_SETTING_LICENSE_PLATE_AND_CREDIT_CARD,
  BINDING_IS_SETTED,
} from 'use-app';
import repo from 'service/repository';
import { PATH } from 'config';

export const INITIALIZE = 'initialize';
export const CHANGE_3D_VALIDATION = 'change_3d_validation';
export const CHANGE_SETTING_DIALOG_SHOW = 'change_setting_dialog_show';
export const CHANGE_REMOVE_DIALOG_SHOW = 'change_remove_dialog_show';
export const CHANGE_UPDATE_DIALOG_SHOW = 'change_update_dialog_show';
export const SHOW_LOADING = 'show_loading';
export const HIDE_LOADING = 'hide_loading';

const useMochiPayFlow = () => {
  const { state: appState, dispatch: appDispatch, showFailMessage, showSuccessMessage } = useAppContext();
  const history = useHistory();
  const initState = {
    theme: 'default',
    currentCreditCard: null,
    init3dValidation: false,
    settingDialogShow: false,
    removeDialogShow: false,
    loading: false,
  };

  const change3dValidation = (state, payload) => assign({}, state, { init3dValidation: payload });
  const changeSettingDialogShow = (state, payload) => assign({}, state, { settingDialogShow: payload });
  const changeRemoveDialogShow = (state, payload) => assign({}, state, { removeDialogShow: payload });
  const showLoading = state => assign({}, state, { loading: true });
  const hideLoading = state => assign({}, state, { loading: false });

  const initialize = () => {
    const currentCreditCard = appState.me ? appState.me.currentCreditCard : null;
    const lastPaymentSuccess = get(currentCreditCard, 'lastPaymentSuccess', true);
    let initializeState = {
      theme: 'default',
      currentCreditCard: currentCreditCard,
    };

    if (lastPaymentSuccess) {
      initializeState = assign({}, initializeState, {
        theme: 'default-distributor',
      });
    } else {
      initializeState = assign({}, initializeState, {
        theme: 'last-payment-fail',
      });
    }

    return assign({}, initState, initializeState);
  };

  const initWallet = callback => {
    repo
      .initMochipayValidation()
      .then(value => {
        callback(value);
      })
      .catch(error => {
        showFailMessage(error);
      });
  };

  const createWallet = (token, transactionId, callback, search) => {
    dispatch({
      type: SHOW_LOADING,
    });
    repo
      .bindMochipayWallet(token, transactionId)
      .then(() => {
        if (
          (appState.nowSettingCreditCard || appState.nowSettingLicensePlateAndCreditCard) &&
          appState.setFrom === 'autopay'
        ) {
          return repo.updateUserInfo(undefined, undefined, undefined, true);
        } else {
          return repo.fetchUserInfo();
        }
      })
      .then(value => {
        appDispatch({
          type: BINDING_IS_SETTED,
        });

        // 付款設定是ㄧ路 replace 上來最後要在 replace 回 main
        // 在堆上 setting page

        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        appDispatch({
          type: NOW_SETTING_CREDIT_CARD,
          payload: false,
        });
        appDispatch({
          type: NOW_SETTING_LICENSE_PLATE_AND_CREDIT_CARD,
          payload: false,
        });
        showSuccessMessage('綁定成功');
      })
      .catch(error => {
        // 付款設定是ㄧ路 replace 上來最後要在 replace 回 main
        // 在堆上 setting page
        showFailMessage(error);
      })
      .finally(() => {
        dispatch({
          type: HIDE_LOADING,
        });
        dispatch({ type: CHANGE_3D_VALIDATION, payload: false });

        history.replace(PATH.MAIN);
        if (search) {
          let { originPath, searchName, searchContent } = search;
          if (!!searchName && searchName !== 'undefined') {
            history.push(`/${originPath}?${searchName}=${searchContent}`);
          } else {
            history.push(`/${originPath}`);
          }
        } else {
          history.push(PATH.MOCHIPAY_FLOW_SETTING);
        }

        callback();
      });
  };

  const bindCreditCardFail = (message, callback, search) => {
    appDispatch({
      type: SHOW_APP_MESSAGE,
      payload: {
        type: 'failure',
        message: message,
      },
    });
    history.replace(PATH.MAIN);
    if (search) {
      let { originPath, searchName, searchContent } = search;
      if (!!searchName && searchName !== 'undefined') {
        history.push(`/${originPath}?${searchName}=${searchContent}`);
      } else {
        history.push(`/${originPath}`);
      }
    } else {
      history.push(PATH.MOCHIPAY_FLOW_SETTING);
    }

    callback();
  };

  const removeWallet = () => {
    repo
      .deleteCreditCard()
      .then(repo.fetchUserInfo)
      .then(data => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: data,
        });
        dispatch({ type: INITIALIZE });
      })
      .catch(error => {
        showFailMessage(error);
      });
  };

  const reducer = createReducer(
    {
      [INITIALIZE]: initialize,
      [CHANGE_3D_VALIDATION]: change3dValidation,
      [CHANGE_SETTING_DIALOG_SHOW]: changeSettingDialogShow,
      [CHANGE_REMOVE_DIALOG_SHOW]: changeRemoveDialogShow,
      [SHOW_LOADING]: showLoading,
      [HIDE_LOADING]: hideLoading,
    },
    initState,
    true
  );

  const [state, dispatch] = useReducer(reducer, initState);

  return { state, dispatch, initWallet, createWallet, removeWallet, bindCreditCardFail };
};

const [MochipayFlowProvider, useMochiPayFlowContext] = constate(useMochiPayFlow);
export { MochipayFlowProvider, useMochiPayFlowContext };
